import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primeicons/primeicons.css'
import { useCallback, useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { useNavigate } from 'react-router';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import httpService from '../../../../services/httpService';
import { ApiEndpoints, Constants } from '../../../../constants/appConstants';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useAuthContext } from '../../../../Context/AuthContext';
import { ProviderType, ReviewStatusCode } from '../../ProviderProfile/models';
import { Calendar } from 'primereact/calendar';
import { FilterMatchMode, FilterOperator, FilterService } from 'primereact/api';
import { useAppContext } from '../../../../Context';
import MultipartFileUploadComponent from '../../../FileUpload/MultpartFileUploadComponent';
import { ScoKpiDashboardComponent } from './SCOKpiDashboardComponent';
import { getClientLocalDate, formatClientLocalDate } from '../../../../services/dateHelper';

FilterService.register('dateIs', (value: any, filter: any) => {
    if (filter === undefined || filter === null) {
        return true;
    }
    if (value === undefined || value === null) {
        return false;
    }
    const normalizedValue = value instanceof Date ? value : getClientLocalDate(value);
    const normalizedFilter = filter instanceof Date ? filter : getClientLocalDate(filter);
    
    if (!normalizedValue || !normalizedFilter) {
        return false;
    }
    return normalizedValue.getTime() === normalizedFilter.getTime();
});

FilterService.register('dateIsNot', (value: any, filter: any) => {
    if (filter === undefined || filter === null) {
        return true;
    }
    if (value === undefined || value === null) {
        return true;
    }
    const normalizedValue = value instanceof Date ? value : getClientLocalDate(value);
    const normalizedFilter = filter instanceof Date ? filter : getClientLocalDate(filter);
    
    if (!normalizedValue || !normalizedFilter) {
        return true;
    }
    return normalizedValue.getTime() !== normalizedFilter.getTime();
});
const logPfpSCOError = (methodName: string, error: unknown) => {
    const messages: string[] = [];
    let current: unknown = error;
    for (let depth = 0; depth < 3 && current; depth++) {
        if (current instanceof Error) {
            messages.push(current.message);
            current = (current as Error & { cause?: unknown }).cause;
        } else if (typeof current === 'object' && current !== null) {
            const details = current as { message?: unknown; cause?: unknown; response?: { status?: number }; status?: number };
            if (typeof details.message === 'string') messages.push(details.message);
            const status = details.response?.status ?? details.status;
            if (typeof status === 'number') messages.push(`HTTP status ${status}`);
            current = details.cause;
        } else {
            break;
        }
    }
    console.error(`[PfpSCOProvidersComponent.${methodName}] ${messages.join(' | ') || 'Request failed'}`);
};

export const PfpSCOProvidersComponent = () => {

    const navigate = useNavigate()
    const [data, setData] = useState([])
    const [IsActiveReview, setIsActiveReview] = useState(Boolean)
    const [filteredData, setFilteredData] = useState(data);
    const [isLoading, setLoaing] = useState(false);
    const [selectedProvider, setSelectedProvider] = useState<any>(null);
    const [globalFilterValue, setGlobalFilterValue] = useState<string>('');
    const globalSearchKeys = ['mpi', 'providerAgencyName', 'reviewStatus', 'currentTier'];
    const [visible, setVisible] = useState(false);
    const { isAdministrator, isFinalReviewer } = useAuthContext();
    const [filters, setFilters] = useState<any>(null);
    const { reviewYear } = useAppContext();
    const [kpiRefreshTrigger, setKpiRefreshTrigger] = useState(0);
    const [showDisputeEndDialog, setShowDisputeEndDialog] = useState(false);
    const [IsActiveDispute, setIsActiveDispute] = useState(Boolean);
  // Loader states for action buttons
    const [reviewCycleLoading, setReviewCycleLoading] = useState(false);
    const [endReviewCycleLoading, setEndReviewCycleLoading] = useState(false);
    const [disputeCycleLoading, setDisputeCycleLoading] = useState(false);
    const [endDisputeCycleLoading, setEndDisputeCycleLoading] = useState(false);
    // useEffect(()=>{
    //     if(isSmeReviewer()){
    //         navigate('/unauthorized');
    //     }
    // }, [isSmeReviewer]);
    // api call onload
    useEffect(() => {
        if (reviewYear) {
            fetchAllProviders();
            setFilters({
                providerType: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                providerAgencyName: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                mpi: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
                reviewStatus: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                reviewerName: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                dateOfTierAssignment: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }] },
                currentTier: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                tierChangeStatus: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                incentivePrograms: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                approvalStatus: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            });
        }
    }, [reviewYear])

    useEffect(() => {
        httpService.get(ApiEndpoints.IsPfpActiveReview)
            .then((response: any) => {
                setIsActiveReview(response?.data)
            }).catch((error: any) => {
                logPfpSCOError('IsPfpActiveReview', error);
            })
            IsActiveDisputeApi();
    }, [])

    const getDateOnly = (date: string) => {
        return getClientLocalDate(date);
    }

    const fetchAllProviders = () => {
        setLoaing(true);
        httpService.get(`${ApiEndpoints.getPfpScoProvidersData}/${reviewYear}`)
            .then((response: any) => {
                const updatedData = response?.data.map((item: any) => ({
                    ...item,
                    dateOfTierAssignment: getDateOnly(item.dateOfTierAssignment), // Convert string to Date object
                }));
                setData(updatedData);
                setFilteredData(updatedData);
                // setKpiData(response?.data);
            }).catch((error: any) => {
                if (error.status == 403 || error.status == 401) {
                    navigate(`/unauthorized`);
                }
                logPfpSCOError('fetchAllProviders', error);
            }).finally(() => {
                // console.log('Finally');
                setLoaing(false);
            })
    }

    const parentSearchHandler = useCallback((value: any, searchColumns: string[], exactMatch: boolean = false) => {
        let filtered = data.filter((item: any) =>
            searchColumns.some((key) => {
                const fieldValue = (item[key] ?? '').toString().toLowerCase();
                if (exactMatch) {
                    return fieldValue === (value ?? '').toString().toLowerCase();
                }
                return fieldValue.includes((value ?? '').toString().toLowerCase());
            })
        );
        if (value === globalFilterValue) {
            value = '';
            filtered = data;
        }
        setGlobalFilterValue(value);
        setFilteredData(filtered);
    }, [data, globalFilterValue]);

    const handleSearch = (e: any) => {

        let value = "";
        if (Array.isArray(e) && typeof (e.join('')) == "string") {
            value = e.join('');
        }
        else value = e.target.value;
        let filtered = data.filter((item: any) =>
            globalSearchKeys.some((key) => {
                const fieldValue = String(item[key]).toLowerCase();
                return fieldValue.includes(value?.toLowerCase());
            })
        );
        if (value == globalFilterValue) {
            value = '';
            filtered = data;
        }


        setGlobalFilterValue(value);
        setFilteredData(filtered);
    }

  const BeginReviewCycle = () => {
    setReviewCycleLoading(true);
    httpService.get(ApiEndpoints.BeginPfpReviewCycle)
      .then((response: any) => {
        if (response.status === 200) {
          setIsActiveReview(true);
          fetchAllProviders();
          setKpiRefreshTrigger(prev => prev + 1);
        }
      })
      .catch((error: unknown) => {
            logPfpSCOError('BeginReviewCycle', error);
        })
        .finally(() => {
        setReviewCycleLoading(false);
      });
  };

 const EndReviewCycle = () => {
    setEndReviewCycleLoading(true);
    httpService.get(ApiEndpoints.EndPfpReviewCycle)
      .then((response: any) => {
        if (response.status === 200) {
          setIsActiveReview(false);
        }
      })
      .catch((error: unknown) => {
            logPfpSCOError('EndReviewCycle', error);
        })
        .finally(() => {
        setEndReviewCycleLoading(false);
      });
  };

    //Dispute Method Region

    const BeginDisputeCycle = () => {
        setDisputeCycleLoading(true);
        httpService.get(ApiEndpoints.BeginPfpDisputeCycle)
            .then((response: any) => {
                if (response.status === 200) {
                    setIsActiveDispute(true);
                    ChangePfpReviewStatusForDispute();
                }
            })
            .catch((error: unknown) => {
            logPfpSCOError('BeginDisputeCycle', error);
        })
        .finally(() => {
                setDisputeCycleLoading(false);
            });
    };

    const EndDisputeCycle = () => {
        setEndDisputeCycleLoading(true);
        httpService.get(ApiEndpoints.EndPfpDisputeCycle)
            .then((response: any) => {
                if (response.status === 200) {
                    setIsActiveDispute(false);
                }
            })
            .catch((error: unknown) => {
            logPfpSCOError('EndDisputeCycle', error);
        })
        .finally(() => {
                setEndDisputeCycleLoading(false);
                fetchAllProviders();
                setKpiRefreshTrigger(prev=>prev+1)
            });
    };

    const IsActiveDisputeApi = () => {
        httpService
            .get(ApiEndpoints.IsPfpActiveDisputeCycle)
            .then((response: any) => {
                setIsActiveDispute(response?.data);
            })
            .catch((error: any) => {
                logPfpSCOError('IsActiveDisputeApi', error);
            });
    }

    
  const ChangePfpReviewStatusForDispute = () =>{
    httpService
      .get(`${ApiEndpoints.ChangePfpReviewStatusForDispute}/${ProviderType.SCO}`)
      .catch((error: any) => {
        logPfpSCOError('ChangePfpReviewStatusForDispute', error);
      })
      .finally(()=>{
        fetchAllProviders();
        setKpiRefreshTrigger(prev=>prev+1)
      });
  }

    const confirmEndDisputeCycle = () => {
        setShowDisputeEndDialog(true);
    };

    const onConfirmEndDispute = () => {
        setShowDisputeEndDialog(false);
        EndDisputeCycle();
    };

    const onCancelEndDispute = () => {
        setShowDisputeEndDialog(false);
    };
    //End Dispute Method Region


    const [showConfirmDialog, setShowConfirmDialog] = useState(false);

    const confirmEndReview = () => {
        setShowConfirmDialog(true);
    };

    const onConfirmEndReview = () => {
        setShowConfirmDialog(false);
        EndReviewCycle();
    };

    const onCancelEndReview = () => {
        setShowConfirmDialog(false);
    };


    const onSelectedProviderChange = (e: any) => {
        navigate(`/pfp/providerProfile`, { state: { provider: e.value } });
        setSelectedProvider(e.value);
    }
    const renderHeader = () => {
        return (
            <div className="flex flex-wrap gap-2 justify-content-between ">
                <IconField iconPosition="left" style={{ alignItems: 'end' }}>
                    <InputIcon className="pi pi-search" />
                    <InputText className="width-150" value={globalFilterValue} onChange={handleSearch} placeholder="Search Agency Name or MPI" />
                </IconField>
            </div>
        );
    };
    const showDateOfTierAssignment = (rowData: any) => {
        if (rowData.dateOfTierAssignment) {
            return formatClientLocalDate(rowData.dateOfTierAssignment);
        }
    }
    const getKpiIsEnabled = () => Constants.KPI_IS_ENABLED;

    // const tierChangeStatusTemplate = (rowData: any) => {
    //     let status = rowData.tierChangeStatus;
    //     return (
    //         status && status.toLowerCase() === 'yes' ?
    //             <div className="flex">
    //                 <span style={{ paddingRight: "5px" }}>{status}</span>
    //                 <Tooltip target=".status" />
    //                 <i
    //                     className="pi pi-info-circle status"
    //                     data-pr-tooltip={"Previous Tier: " + (rowData.previousTier || 'Not Available')}
    //                     data-pr-position="top"
    //                     style={{ alignContent: "center" }}
    //                 />
    //             </div>
    //             :
    //             status
    //     );
    // }

    const dateFilterTemplate = (options: any) => {
        return <Calendar value={options.value} onChange={(e) => {
    const selectedDate = e.value;
    if (selectedDate) {
        const clientDate = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), 0, 0, 0, 0);
        options.filterCallback(clientDate, options.index);
    } else {
        options.filterCallback(null, options.index);
    }
}} dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" mask="99/99/9999" />;
    };
    // const getDecisionLetter = (mpiId: string) => {
    //     console.log("getDecisionLetter:", mpiId)
    //     httpService.get(`${ApiEndpoints.GenerateDecisionLetter}/${mpiId}/${reviewYear}`)
    //         .then((response: any) => {
    //             if (response.status === 200) {
    //                 console.log("Generated Decision Letter");
    //             }
    //         })
    // }
    // const DownloadDecisionLetter = (rowData: any) => {
    //     return (
    //         <Button link onClick={() => { getDecisionLetter(rowData.mpi) }} label='Decision Letter'></Button>
    //     )
    // };
    const header = renderHeader();
    return (
        <>
            {/* <MegaMenu model={navigationItems} breakpoint='960px' /> */}
            <div className="card">
                <div style={{ display: 'flex', justifyContent: 'flex-end', flexWrap: 'wrap', gap: '10px', padding: '15px 25px', height: '80px', minHeight: '5rem', }}>
                    {(isAdministrator() && !isLoading) && (
            <>
              {/* <Button size='small' className="p-button-secondary" onClick={() => navigate(`/standards`)}>
                                Performance Standards
                            </Button > */}
              {IsActiveReview == false && IsActiveDispute == false && (
                <Button
                  size="small"
                  className="p-button-secondary"
                  onClick={BeginReviewCycle}
                  disabled={reviewCycleLoading}
                >
                  {reviewCycleLoading ? (
                    <><i className="pi pi-spin pi-spinner" style={{ marginRight: 8 }} />Begin Review Cycle</>
                  ) : (
                    "Begin Review Cycle"
                  )}
                </Button>
              )}
              {IsActiveReview == true && IsActiveDispute == false && (
                <Button
                  size="small"
                  className="p-button-secondary"
                  onClick={confirmEndReview}
                  disabled={endReviewCycleLoading || disputeCycleLoading}
                >
                  {endReviewCycleLoading ? (
                    <><i className="pi pi-spin pi-spinner" style={{ marginRight: 8 }} />End Review Cycle</>
                  ) : (
                    "End Review Cycle"
                  )}
                </Button>
              )}
              {IsActiveReview == true && IsActiveDispute == false && (
                <Button
                  size="small"
                  className="p-button-secondary"
                  onClick={BeginDisputeCycle}
                  disabled={disputeCycleLoading || endReviewCycleLoading}
                >
                  {disputeCycleLoading ? (
                    <><i className="pi pi-spin pi-spinner" style={{ marginRight: 8 }} />Begin Resolution Cycle</>
                  ) : (
                    "Begin Resolution Cycle"
                  )}
                </Button>
              )}
              {IsActiveReview == true && IsActiveDispute == true && (
                <Button
                  size="small"
                  className="p-button-secondary"
                  onClick={confirmEndDisputeCycle}
                  disabled={endDisputeCycleLoading}
                >
                  {endDisputeCycleLoading ? (
                    <><i className="pi pi-spin pi-spinner" style={{ marginRight: 8 }} />End Resolution Cycle</>
                  ) : (
                    "End Resolution Cycle"
                  )}
                </Button>
              )}
            </>
          )}
                    {/* {IsActiveReview == false ?
                        <Button size='small' className="p-button-secondary" //style={{ cursor: 'pointer', backgroundColor: '#007acc', color: 'white', padding: '10px', border: 'none', borderRadius: '5px', whiteSpace: 'pre-line' }}
                            onClick={() => setVisible(true)} >
                            Upload File
                        </Button> :
                        <Button size='small' className="p-button-secondary" //style={{ cursor: 'pointer', backgroundColor: '#007acc', color: 'white', padding: '10px', border: 'none', borderRadius: '5px', whiteSpace: 'pre-line' }}
                            onClick={() => setVisible(true)} >
                            Upload CLS Data
                        </Button>
                    } */}
                </div>

                <div className="kpi-pie-chart-wrapper">
                    {getKpiIsEnabled() && <ScoKpiDashboardComponent
                        key={kpiRefreshTrigger}
                        searchHandler={parentSearchHandler}
                    />}
                </div>


                <Dialog
                    header="Upload"
                    visible={visible}
                    onHide={() => setVisible(false)}
                ><div className="flex flex-column px-8 py-5 gap-4" style={{ borderRadius: '12px', width: '1000px', height: 'auto', minHeight: '300px' }}>
                        <MultipartFileUploadComponent allowedExtension="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" maxSize={100000}
                            onFileuploaded={() => { fetchAllProviders() }} />
                    </div>
                    <div>
                        <p style={{ textAlign: "center" }}>click <a style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }} onClick={() => navigate(`/Upload`)} >
                            here</a> to view status of uploaded files
                        </p>
                    </div>
                </Dialog>

                {/* End review cycle confirmation popup */}
                <Dialog
                    header="Confirmation"
                    visible={showConfirmDialog}
                    onHide={onCancelEndReview}
                    footer={
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>

                            <Button label="No" icon="pi pi-times" onClick={onCancelEndReview} className="p-button-text" />
                            <Button label="Yes" icon="pi pi-check" onClick={onConfirmEndReview} autoFocus />
                        </div>
                    }
                >
                    <div>
                        {data.some((provider: any) => provider.reviewStatusCode?.toLowerCase() !== ReviewStatusCode.ReviewCompleted?.toLowerCase()) && (
                            <p style={{ color: 'red' }}>Some providers' reviews are not yet completed.</p>
                        )}
                        <p>Are you sure you want to <b>End the review cycle</b>?</p>
                    </div>
                </Dialog>

                <Dialog
                    header="Confirmation"
                    visible={showDisputeEndDialog}
                    onHide={onCancelEndDispute}
                    footer={
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <Button
                                label="No"
                                icon="pi pi-times"
                                onClick={onCancelEndDispute}
                                className="p-button-text"
                            />
                            <Button
                                label="Yes"
                                icon="pi pi-check"
                                onClick={onConfirmEndDispute}
                                autoFocus
                            />
                        </div>
                    }
                >
                    <p>
                        Are you sure you want to <b>End the Resolution cycle</b>?
                    </p>
                </Dialog>


                <div>
                    <DataTable value={filteredData} paginator header={header} rows={5} rowsPerPageOptions={[5, 10, 25, 50]} loading={isLoading}
                        filters={filters} selectionMode="single" selection={selectedProvider} onSelectionChange={onSelectedProviderChange} dataKey="providerId" emptyMessage="No provider found."
                    >
                        <Column field="providerType" header="PBC Type" sortable filter filterPlaceholder="Filter by PBC Type" style={{ minWidth: '14rem' }} />
                        <Column field="providerAgencyName" header="Agency Name" sortable filter filterPlaceholder="Filter by Agency Name" style={{ minWidth: '14rem' }} />
                        <Column field="mpi" header="MPI" sortable filter filterPlaceholder="Filter by MPI" style={{ minWidth: '14rem' }} />
                        <Column field="incentivePrograms" header="Initiative(s)" sortable filter filterPlaceholder="Filter by Initiative(s)" style={{ minWidth: '14rem' }} />
                        <Column field="reviewStatus" header="Review Status" sortable filter filterPlaceholder="Filter by Review Status" style={{ minWidth: '14rem' }} />
                        <Column field="reviewerName" header="Reviewer" sortable filter filterPlaceholder="Filter by Reviewer" style={{ minWidth: '14rem' }} />
                        {(isAdministrator() || isFinalReviewer()) && (
                            <Column field="approvalStatus" header="Approval Status" sortable filter filterPlaceholder="Filter by Approval Status" style={{ minWidth: '14rem' }} />
                        )}
                        {(isAdministrator() || isFinalReviewer()) && (
                            <Column field="dateOfTierAssignment" header="Completion Date" sortable filter
                                dataType="date"
                                filterElement={dateFilterTemplate}
                                filterPlaceholder="Filter by Completion Date" style={{ minWidth: '14rem' }} body={(rowData) => showDateOfTierAssignment(rowData)} />
                        )}
                        {/* <Column header="Decision Letter" sortable body={DownloadDecisionLetter} style={{ minWidth: '14rem' }} /> */}
                    </DataTable>
                </div>

            </div >
        </>
    )
}